import React, {useState,useEffect} from 'react';
import { NavLink} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { dynamicUrl,LangValue,formatBytes } from './Function';
import { Container,Row,Col,Nav,NavDropdown,Placeholder } from 'react-bootstrap';
const MegaMenu = ({ menu,toggleDropdown }) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const fileSize = formatBytes(2192478);
    return (
        <Container className='py-2 px-4'>
            {menu.sp_id === 2 && 
            <Row>
                <Col md={4}>
                    <h4 className='title'>{t('Overview')}</h4>                    
                    <Nav className="flex-column">
                        <DynamicLink spId={10} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={19} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={58} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={185} menu={menu} toggleDropdown={toggleDropdown}/>
                    </Nav>
                </Col>
                <Col md={4}>
                    <h4 className='title'>{t('Administration')}</h4>
                    <Nav className="flex-column">
                        <DynamicLink spId={348} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={20} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={257} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={56} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={284} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={293} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={61} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={62} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={63} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={64} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={65} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={59} menu={menu} toggleDropdown={toggleDropdown}/>
                    </Nav>
                </Col>
                <Col md={4}>
                    <h4 className='title'>{t('Regulations')}</h4>
                    <Nav className="flex-column">
                        <DynamicLink spId={57} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={66} menu={menu} toggleDropdown={toggleDropdown}/>
                    </Nav>
                </Col>
            </Row>
            }
            {menu.sp_id === 4 && 
            <Row>
                <Col md={4}>
                    <h4 className='title'>{t('Academics')}</h4>                    
                    <Nav className="flex-column">
                        <DynamicLink spId={21} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={22} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={23} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={24} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={25} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={26} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={27} menu={menu} toggleDropdown={toggleDropdown}/>
                    </Nav>
                </Col>
                <Col md={4}>
                    <h4 className='title'>{t('Departments')}</h4>
                    <Nav className="flex-column">
                        <DynamicLink spId={12} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={13} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={14} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={15} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={11} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={16} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={17} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={18} menu={menu} toggleDropdown={toggleDropdown}/>
                    </Nav>
                </Col>
                <Col md={4}>
                    <h4 className='title'>{t('Centers')}</h4>
                    <Nav className="flex-column">
                        <NavDropdown.Item href='https://www.anveshanfoundation.org/' aria-label={t('IIC_ALT')} className='d-flex' target="_blank" rel="noopener noreferrer">
                        <i className="bi bi-chevron-right me-2"></i>{t('IIC_ALT')}
                        </NavDropdown.Item>
                        <NavDropdown.Item href={global.config.uploadPath+'1804948305.pdf'} aria-label={t('CEAI_ALT')} className='d-flex' target="_blank" rel="noopener noreferrer">
                        <i className="bi bi-filetype-pdf me-2" aria-hidden="true"></i>{t('CEAI_ALT')}, {fileSize}
                        </NavDropdown.Item>
                        <NavDropdown.Item href="https://csd.igdtuw.ac.in" aria-label={t('CSD_ALT')} className='d-flex' target="_blank" rel="noopener noreferrer">
                            <i className="bi bi-chevron-right me-2"></i>{t('CSD_ALT')}
                        </NavDropdown.Item>
                        <NavDropdown.Item href="https://sites.google.com/view/advanced-mechatronics/home" aria-label={t('CEAMS_ALT')} className='d-flex' target="_blank" rel="noopener noreferrer" >
                            <i className="bi bi-chevron-right me-2"></i>{t('CEAMS_ALT')}
                        </NavDropdown.Item>
                        <NavDropdown.Item href={appLanguage === 'hi' ? '/प्रसन्नता-के-विज्ञान-के-लिए-रेखी-सीओई' : '/rekhi-coe-for-science-of-happiness'} aria-label={t('RekhiCoE')} className='d-flex' >
                            <i className="bi bi-chevron-right me-2"></i>{t('RekhiCoE')}
                        </NavDropdown.Item>                    
                    </Nav>
                </Col>
            </Row>
            }
            {menu.sp_id === 5 && 
            <Row>
                <Col md={4}>
                    <h4 className='title'>{t('StudentLife')}</h4>                    
                    <Nav className="flex-column">
                        <DynamicLink spId={5} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={28} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={34} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={352} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={29} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={30} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={31} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={32} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={33} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={144} menu={menu} toggleDropdown={toggleDropdown}/>
                    </Nav>
                </Col>
                <Col md={4}>
                    <h4 className='title'>{t('Facilities')}</h4>
                    <Nav className="flex-column">
                        <DynamicLink spId={147} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={148} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={149} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={150} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={151} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={152} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={153} menu={menu} toggleDropdown={toggleDropdown}/>
                    </Nav>
                </Col>
                <Col md={4}>
                    <h4 className='title'>{t('Placements')}</h4>
                    <Nav className="flex-column">
                        <DynamicLink spId={204} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={205} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={206} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={208} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={209} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={210} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={211} menu={menu} toggleDropdown={toggleDropdown}/>                        
                    </Nav>
                </Col>
            </Row>
            }
            {menu.sp_id === 6 && 
            <Row>
                <Col md={7}>
                    <h4 className='title'>{t('RandC')}</h4>
                    <Row>
                        <Col>
                            <Nav className="flex-column">
                                <DynamicLink spId={35} menu={menu} toggleDropdown={toggleDropdown}/>                                
                                <DynamicLink spId={38} menu={menu} toggleDropdown={toggleDropdown}/>                                
                                <DynamicLink spId={40} menu={menu} toggleDropdown={toggleDropdown}/>
                                <DynamicLink spId={36} menu={menu} toggleDropdown={toggleDropdown}/>
                                <DynamicLink spId={37} menu={menu} toggleDropdown={toggleDropdown}/>
                                <DynamicLink spId={39} menu={menu} toggleDropdown={toggleDropdown}/>
                                <DynamicLink spId={180} menu={menu} toggleDropdown={toggleDropdown}/>
                                <DynamicLink spId={202} menu={menu} toggleDropdown={toggleDropdown}/>                                
                            </Nav>
                        </Col>
                        <Col>
                            <Nav className="flex-column">
                                <DynamicLink spId={42} menu={menu} toggleDropdown={toggleDropdown}/>
                                <DynamicLink spId={41} menu={menu} toggleDropdown={toggleDropdown}/>
                                <DynamicLink spId={275} menu={menu} toggleDropdown={toggleDropdown}/>
                                <DynamicLink spId={243} menu={menu} toggleDropdown={toggleDropdown}/>
                                <DynamicLink spId={294} menu={menu} toggleDropdown={toggleDropdown}/>
                                <DynamicLink spId={353} menu={menu} toggleDropdown={toggleDropdown}/>
                                <DynamicLink spId={371} menu={menu} toggleDropdown={toggleDropdown}/>
                            </Nav>
                        </Col>
                    </Row>                    
                </Col>
                <Col md={5}>
                    <h4 className='title'>{t('IRD')}</h4>
                    <Nav className="flex-column">
                        <DynamicLink spId={261} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={273} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={274} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={43} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={74} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={244} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={44} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={272} menu={menu} toggleDropdown={toggleDropdown}/>
                        <DynamicLink spId={364} menu={menu} toggleDropdown={toggleDropdown}/>           
                    </Nav>
                </Col>
            </Row>
            }            
        </Container>
    );
};
  
export default MegaMenu;

const DynamicLink = ({spId, menu, toggleDropdown}) => 
{
    const[isLoading, setLoading] = useState(true);
    const[Links,setLinks]=useState([]);
    useEffect(()=>
    {
        const getDynamicLink = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"menu/MenuById/"+spId);
                const result = await response.json();
                setLinks(result);
                setLoading(false);
            
            } catch (error) 
            {
                console.error('DynamicLink : Error', error.message);
            }
        };
        const result = findSubmenuById(menu?.submenu, spId);
        if(result)
        {
            setLinks([result]);
            setLoading(false);
        }
        else
        {
            getDynamicLink();
        }
        // eslint-disable-next-line
    },[spId])
    const findSubmenuById = (submenus, id) => {
        return submenus.find(submenu => submenu.sp_id === id);
    };
    return (
        <React.Fragment>
        {isLoading ? (
            <NavDropdown.Item>
                <Placeholder xs={12} style={{minHeight:"0.6em"}} />
            </NavDropdown.Item>
        ) : (
            <React.Fragment>
            {Links.map((sp,index)=>(
                <NavLink key={index} className={({ isActive }) => (isActive ? 'active dropdown-item d-flex' : 'dropdown-item d-flex')} 
                to={dynamicUrl(sp)} aria-label={LangValue(sp,'sp_name')} 
                onClick={(e) => { e.stopPropagation();toggleDropdown(false); }}
                >
                    <i className="bi bi-chevron-right me-2"></i>{LangValue(sp,'sp_name')}
                </NavLink>
            ))}
            </React.Fragment>
        )}
        </React.Fragment>
    );
}